import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-labels _ml-2",
  "data-qa": "badge:Secret"
}
const _hoisted_2 = { class: "gfu-project-stretch-goal-card__body" }
const _hoisted_3 = { class: "gfu-media gfu-media--middle _mb-1" }
const _hoisted_4 = {
  class: "gfu-media__body gfu-bt gfu-bt--caption _tc--dark-gray",
  "data-qa": "project-stretch-goal:Target"
}
const _hoisted_5 = {
  "format-key": "0",
  class: "_whs-nw"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "gfu-project-stretch-goal-card__title gfu-hd gfu-hd--h3 gfu-hd--decorative _mb-1",
  "data-qa": "project-stretch-goal-name"
}
const _hoisted_8 = {
  class: "gfu-bt gfu-bt--caption",
  "data-qa": "project-stretch-goals:CurrentGoalProgress"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_router_link = _resolveComponent("router-link")
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_themed_image = _resolveComponent("themed-image")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-project-stretch-goal-card gfu-card', {'gfu-project-stretch-goal-card--featured': $props.stretchGoal.isFeatured }])
  }, [
    ($options.isSecretBadgeVisible)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_component_base_badge, { theme: "accent" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Project.SecretStretchGoalBadgeLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['gfu-project-stretch-goal-card__contents', {'gfu-project-stretch-goal-card__contents--featured': $props.stretchGoal.isFeatured }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(['gfu-project-stretch-goal-icon _mr-1',
                                  { 'gfu-project-stretch-goal-icon--success': $props.stretchGoal.isUnlocked } ])
          }, [
            ($props.stretchGoal.isUnlocked)
              ? (_openBlock(), _createBlock(_component_base_icon, {
                  key: 0,
                  name: "check"
                }))
              : (_openBlock(), _createBlock(_component_base_icon, {
                  key: 1,
                  name: "lock"
                }))
          ], 2 /* CLASS */),
          _createElementVNode("div", _hoisted_4, [
            ($props.stretchGoal.targetType !== $data.stretchGoalTargetTypes.backedFunds)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString($setup.resolveStatusText($props.stretchGoal)), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createBlock(_component_display_currency_value, {
                  key: 1,
                  tag: "span"
                }, {
                  "tooltip-content": _withCtx(() => [
                    _createVNode(_component_localize, {
                      resource: _ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$format($props.stretchGoal.targetValue, 'C0')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["resource"])
                  ]),
                  content: _withCtx(({ displayCurrency }) => [
                    _createTextVNode(_toDisplayString($setup.resolveStatusText($props.stretchGoal, displayCurrency.symbol, displayCurrency.relativeFactor)), 1 /* TEXT */)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.resolveStatusText($props.stretchGoal, $props.currencySymbol)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })),
            ($options.hasDescription)
              ? (_openBlock(), _createBlock(_component_tooltip, { key: 2 }, {
                  content: _withCtx(() => [
                    ($options.targetDescription)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: $options.targetDescription
                        }, null, 8 /* PROPS */, _hoisted_6))
                      : _createCommentVNode("v-if", true)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "circle-info",
                      class: "_ml-1"
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("h3", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "gfu-link gfu-link--nofx",
            to: $options.route
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.stretchGoal.name), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        (!$props.stretchGoal.isUnlocked && $props.stretchGoal.isAutomatic)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.resolveProgress($props.stretchGoal, $options.currentCurrencySymbol, $options.currentCurrencyFactor)), 1 /* TEXT */),
              _createVNode(_component_progress_bar, {
                value: $props.stretchGoal.value,
                max: $props.stretchGoal.targetValue,
                "progression-class": "gfu-progress-bar__progression--accent"
              }, null, 8 /* PROPS */, ["value", "max"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-project-stretch-goal-card__media gfu-embed gfu-embed--1x1', { '_shrink-0' : !$props.stretchGoal.isFeatured}])
      }, [
        ($props.displayImage)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: $options.route,
              class: "gfu-embed__item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_themed_image, {
                  src: $props.stretchGoal.imageUrl,
                  alt: $props.stretchGoal.name,
                  class: "gfu-embed__item",
                  loading: "lazy"
                }, null, 8 /* PROPS */, ["src", "alt"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}